import { SVGProps } from 'react';

const MoveDiagonal2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13 19h6v-6m0 6L5 5m6 0H5v6"
    />
  </svg>
);
export default MoveDiagonal2;
